'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _buttonGroup = require('./button-group');

var _buttonGroup2 = _interopRequireDefault(_buttonGroup);

var _linkGroup = require('./link-group');

var _linkGroup2 = _interopRequireDefault(_linkGroup);

var _prizeDisplay = require('./prize-display');

var _prizeDisplay2 = _interopRequireDefault(_prizeDisplay);

var _anonymousLoginButton = require('./anonymous/anonymous-login-button');

var _anonymousLoginButton2 = _interopRequireDefault(_anonymousLoginButton);

var _registrationOptions = require('./registration-options');

var _registrationOptions2 = _interopRequireDefault(_registrationOptions);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

/** @class AuthMenu
  * Provides multiple ways to authenticate users.
  */

var AuthMenu = function (_Component) {
  _inherits(AuthMenu, _Component);

  function AuthMenu(props) {
    _classCallCheck(this, AuthMenu);

    var _this = _possibleConstructorReturn(this, (AuthMenu.__proto__ || Object.getPrototypeOf(AuthMenu)).call(this, props));

    _this.state = {};
    return _this;
  }
  /** @function render
    * Renders the authentication menu
    */


  _createClass(AuthMenu, [{
    key: 'render',
    value: function render() {
      // Only render the registry link if the registry is available.
      var registry = window.vexpo.giftRegistry ? _react2.default.createElement(
        _buttonGroup2.default,
        null,
        _react2.default.createElement(
          'button',
          null,
          'Search Gift Registry for Friends and Family'
        )
      ) : null;
      return _react2.default.createElement(
        Wrapper,
        { className: 'auth-content' },
        _react2.default.createElement(_registrationOptions2.default, null),
        'OR',
        _react2.default.createElement(_anonymousLoginButton2.default, null),
        registry
      );
    }
  }]);

  return AuthMenu;
}(_react.Component);

exports.default = AuthMenu;


AuthMenu.propTypes = {};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/auth/auth-menu.js
// module id = 815
// module chunks = 0